// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__N4Oe3","rootSmall":"AddTileButton_rootSmall__XKInq"};